import { Component, OnInit } from '@angular/core';
import {RegistryService} from '../../services/registry.service';
import {Customer} from '../../models/CustomerInfo/Customer';
import {AuthService} from '../../../../services/auth.service';


@Component({
  selector: 'app-customer-profile',
  templateUrl: './customer-profile.component.html',
  styleUrls: ['./customer-profile.component.css']
})
export class CustomerProfileComponent implements OnInit {


  constructor(public registry: RegistryService) {

  }

  ngOnInit(): void {
  }

  placeDeletionRequest(){

    alert("A deletion request was placed. You will get a confirmation email once your request is complete.");
  }

}
